import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Commercial from "@/pages/Commercial";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function LenisBridge() {
  const lenis = useLenis();
  if (typeof window !== "undefined") window.__lenis = lenis;
  return null;
}

function App() {
  return (
    <AuthProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <LenisBridge />
        <div className="App min-h-screen bg-background text-foreground">
          <div className="grain-overlay" aria-hidden="true" />
          <Toaster position="bottom-right" theme="light" />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/commercial" element={<Commercial />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ReactLenis>
    </AuthProvider>
  );
}

export default App;
